import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  ViewEncapsulation
} from '@angular/core';
import {
  InspectionCaseDto,
  InspectionFireTaps
} from '@authority-labs/api-interfaces';
import { Conclusion } from '@authority-labs/enums';

@Component({
  selector: 'authority-labs-fire-taps-test-results',
  templateUrl: './fire-taps-test-results.component.html',
  styleUrls: ['./fire-taps-test-results.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.ShadowDom
})
export class FireTapsTestResultsComponent implements OnInit {
  @Input() inspection: InspectionFireTaps;
  notes: string[] = [];

  ngOnInit(): void {
    this.notes = new InspectionFireTaps(this.inspection)
      .getNotes()
      .filter((note) => note.addNotesToReport && note.notes)
      .filter((note) => !note.notes.includes('undefined'))
      .map((note) => note.notes);
  }

  getConclusion(checkCase: InspectionCaseDto): string {
    if (checkCase.isApplicable) {
      return checkCase.isPassed ? Conclusion.Pass : Conclusion.Fail;
    }

    return Conclusion.NotApplicable;
  }
}
